// frontend/app/src/features/feedback/ui/forms/BugReportForm.jsx
import React, { useState } from 'react';
import { feedbackApi } from '../../api/feedback.api';

const BugReportForm = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    title: '',
    component: 'frontend',
    severity: 'normal',
    description: '',
    steps_to_reproduce: '',
    expected_result: '',
    actual_result: '',
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: '', message: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      await feedbackApi.submitBugReport(formData);
      setStatus({ type: 'success', message: 'БАГ-РЕПОРТ УСПЕШНО ОТПРАВЛЕН! СПАСИБО.' });
      if (onSuccess) setTimeout(onSuccess, 2000);
    } catch (error) {
      const serverError = error.response?.data;
      let errorMsg = 'ОШИБКА ОТПРАВКИ. ПОПРОБУЙТЕ ПОЗЖЕ.';
      
      if (serverError) {
        if (typeof serverError === 'object') {
          errorMsg = Object.entries(serverError)
            .map(([field, msgs]) => `${field.toUpperCase()}: ${Array.isArray(msgs) ? msgs.join(' ') : msgs}`)
            .join(' | ');
        } else if (typeof serverError === 'string') {
          errorMsg = serverError;
        }
      }
      
      setStatus({ type: 'error', message: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="feedback-form">
      <div className="form-group">
        <label>ЗАГОЛОВОК</label>
        <input
          name="title"
          value={formData.title}
          onChange={handleChange}
          placeholder="КРАТКОЕ ОПИСАНИЕ ПРОБЛЕМЫ"
          required
        />
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
        <div className="form-group">
          <label>КОМПОНЕНТ</label>
          <select name="component" value={formData.component} onChange={handleChange}>
            <option value="frontend">ФРОНТЕНД</option>
            <option value="backend">БЭКЕНД</option>
            <option value="api">API</option>
            <option value="randomizer">РАНДОМАЙЗЕР</option>
            <option value="rating">РЕЙТИНГ</option>
            <option value="other">ДРУГОЕ</option>
          </select>
        </div>
        <div className="form-group">
          <label>СЕРЬЁЗНОСТЬ</label>
          <select name="severity" value={formData.severity} onChange={handleChange}>
            <option value="trivial">ТРИВИАЛЬНЫЙ</option>
            <option value="minor">НЕЗНАЧИТЕЛЬНЫЙ</option>
            <option value="normal">ОБЫЧНЫЙ</option>
            <option value="major">СЕРЬЁЗНЫЙ</option>
            <option value="critical">КРИТИЧЕСКИЙ</option>
          </select>
        </div>
      </div>

      <div className="form-group">
        <label>ОПИСАНИЕ И ШАГИ</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="ЧТО ПРОИЗОШЛО И КАК ЭТО ПОВТОРИТЬ?"
          required
        />
      </div>

      <div className="form-group">
        <label>ОЖИДАЕМЫЙ РЕЗУЛЬТАТ</label>
        <input
          name="expected_result"
          value={formData.expected_result}
          onChange={handleChange}
          placeholder="ЧТО ДОЛЖНО БЫЛО ПРОИЗОЙТИ?"
          required
        />
      </div>

      <div className="feedback-form-actions">
        <button type="submit" className="feedback-submit-btn" disabled={loading}>
          {loading ? 'ОТПРАВКА...' : '🐞 ОТПРАВИТЬ БАГ'}
        </button>
      </div>

      {status.message && (
        <div className={`feedback-status-msg ${status.type}`}>
          {status.message}
        </div>
      )}
    </form>
  );
};

export default BugReportForm;
